/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import {
  type ContentLink,
  ContentLinkWithTargetBlankSchema,
} from '@backmarket/http-api/src/api-specs-content/models/content-link'

import {
  LooseRichTextSchema,
  type LoosenRichTextFields,
} from '../types/loose-rich-text'
import type { Equal, ExpectTrue } from '../types/validation'

import { type Image, ImageSchema } from './image'
import type { RichText } from './rich-text'

/* TypeScript */
export type MediaApiProps = {
  technicalName?: Maybe<string>
  image?: Maybe<Image>
  link?: Maybe<ContentLink & { targetBlank?: Maybe<boolean> }>
  subtitle?: Maybe<string>
  title?: Maybe<string>
  rounded?: Maybe<boolean>
  caption?: Maybe<RichText>
}

/* Schemas */
export const MediaApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  image: z.nullish(ImageSchema),
  link: z.nullish(ContentLinkWithTargetBlankSchema),
  subtitle: z.nullish(z.string()),
  title: z.nullish(z.string()),
  rounded: z.nullish(z.boolean()),
  caption: z.nullish(LooseRichTextSchema),
})

/* Schemas validation */
type TestRichTextProps = ExpectTrue<
  Equal<
    LoosenRichTextFields<MediaApiProps>,
    z.infer<typeof MediaApiPropsSchema>
  >
>
